import React, { PureComponent } from 'react';
import cn from 'classnames';

import BrButton from '@components/BrButton';
import BrIcons from '@components/BrIcons';
import BrText from '@components/BrText';
import ColorStyles from '@components/ColorStyles';
import { CookieUtils } from '@components/UtilComponents/UtilFunctions';
import { store } from './singleton';
import './brPopupDialog.scss';

const DialogType = {
  ALERT_WITH_OPTION: 'ALERT_WITH_OPTION',
  ALERT: 'ALERT',
};

export default class BrPopupDialog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { isShow: false, checkedCookie: false, option: {} };
    store.listen(this.handleCall);
  }

  close = () => store.call({});

  handleCall = (option) => {
    if (option.defaultAction && CookieUtils.getCookie(option.identifier)) {
      option.defaultAction();
    } else {
      this.setState({ isShow: !!option.message, checkedCookie: false, option: { ...option } });
    }
  };

  onConfirm = () => {
    const { option, checkedCookie } = this.state;
    if (option.onConfirm) {
      option.onConfirm();
    }
    if (checkedCookie && option.identifier && option.defaultAction) {
      CookieUtils.setCookie(option.identifier, true);
    }
    this.close();
  };

  onCancel = () => {
    if (this.state.option.onCancel) {
      this.state.option.onCancel();
    }
    this.close();
  };

  onBackground = (e) => {
    if (e.target.classList.contains('br-popup-dialog')) {
      if (this.state.option.goBackOption) {
        this.close();
      } else {
        this.onCancel();
      }
    }
  };

  onCrossClick = () => {
    if (this.state.option.goBackOption) {
      this.close();
    } else {
      this.onCancel();
    }
  };

  render() {
    if (!this.state.isShow) { return null; }

    const {
      checkedCookie,
      option: {
        confirmButtonTitle = 'OK',
        cancelButtonTitle = 'Cancel',
        confirmButtonColor = this.state.option.type === DialogType.ALERT_WITH_OPTION
          ? ColorStyles.BGBLUE
          : ColorStyles.GRAY,
        cancelButtonColor = ColorStyles.GRAY,
        title,
        message,
        type,
        identifier,
        defaultAction,
        className,
      },
    } = this.state;

    return (
      <div className="br-popup-dialog" onClick={this.onBackground} data-id="br-popup-dialog">
        <div className={cn('dialog-holder', className)}>
          <div className="dialog-title">
            <p>
              <BrText>{title}</BrText>
            </p>
            <BrIcons.Cross className="title-icon" colorStyle={ColorStyles.GRAY} onClick={this.onCrossClick} />
          </div>
          {typeof message === 'string' ? (
            <div className="dialog-message" dir="auto" dangerouslySetInnerHTML={{ __html: message }} />
          ) : (
            <div className="dialog-message">{message}</div>
          )}
          <div className="dialog-btn-wrap">
            {type === DialogType.ALERT_WITH_OPTION && (
              <BrButton
                className="dialog-btn"
                colorStyle={cancelButtonColor}
                onClick={this.onCancel}
                title={cancelButtonTitle}
              />
            )}
            <BrButton
              className="dialog-btn"
              colorStyle={confirmButtonColor}
              onClick={this.onConfirm}
              title={confirmButtonTitle}
            />
          </div>
          {identifier && defaultAction && (
            <div className="dialog-cookie">
              <label>
                <input
                  type="checkbox"
                  checked={checkedCookie}
                  onClick={() => {
                    this.setState({ checkedCookie: !checkedCookie });
                  }}
                />
                &nbsp;Don't show this alert again
              </label>
            </div>
          )}
        </div>
      </div>
    );
  }
}

BrPopupDialog.openPopupDialog = store.call;
BrPopupDialog.openErrorDialog = (message) => store.call({ title: 'ERROR', message, confirmButtonTitle: 'CLOSE' });
BrPopupDialog.Type = DialogType;
